export function getHiddenPhone(phone) {
  return phone.slice(0, -7) + '*****' + phone.slice(-2);
}
